import {
    DELETEENTITYMAPPING_SUCCESS,
    DELETEENTITYMAPPING_FAILED,
    RESET_DELETEENTITYMAPPING,
    LOADING_DELETEENTITYMAPPING,
    NETWORK_ERROR_DELETEENTITYMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETEENTITYMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case DELETEENTITYMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case DELETEENTITYMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_DELETEENTITYMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_DELETEENTITYMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
